/**
 * Get stored auth user from local storage. Following app session logic:
 * - Will get sessionStorage user if available
 * - Otherwise fallback is Cookie user
 * - If not found returns null
 */
export function getAuthUser(): {
	email: string;
	firstname: string;
	id: string;
	lastname: string;
	locale: string;
	verified: boolean;
} {
	try {
		const cookieUser = document.cookie
			? document.cookie
					.split('; ')
					.find((row) => row.startsWith('z5Store.user='))
					.split('=')[1]
			: null;

		const sessionUser = sessionStorage.getItem('z5Store.user');

		const user = sessionUser
			? JSON.parse(sessionStorage.getItem('z5Store.user'))
			: cookieUser
			? JSON.parse(decodeURIComponent(cookieUser))
			: null;

		return user;
	} catch (e) {
		return null;
	}
}
